import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DisableZoomDirective } from "./disable-zoom.directive";
import { ClickOutsideDirective } from "./click-outside.directive";
import { PopupCeteredDirective } from "./popup-centered.directive";
import { ScrollDownDirective } from "./scroll-down.directive";
import { FontFaceLoaderDirective } from "./font-face-loader.directive";
import { TouchstartOutsideDirective } from "./touchstart-outside.directive";
import { PcpHideRippleDirective } from "./hide-ripple.directive";
import { CrossoriginImageDirective } from "./crossorigin-image.directive";

@NgModule({
    imports: [CommonModule, DisableZoomDirective,
        ClickOutsideDirective,
        TouchstartOutsideDirective,
        PopupCeteredDirective,
        FontFaceLoaderDirective,
        ScrollDownDirective,
        PcpHideRippleDirective,
        CrossoriginImageDirective,
    ],
    exports: [
        DisableZoomDirective,
        ClickOutsideDirective,
        TouchstartOutsideDirective,
        PopupCeteredDirective,
        ScrollDownDirective,
        FontFaceLoaderDirective,
        PcpHideRippleDirective,
        CrossoriginImageDirective,
    ]
})
export class SharedUiDirectivesModule {}
